import { Heading } from '@abyss/web/ui/Heading';
import { IconMaterial } from '@abyss/web/ui/IconMaterial';
import { Popover } from '@abyss/web/ui/Popover';
import { find } from 'lodash';
import React, { useEffect, useMemo, useState } from 'react';

import { Disposition } from '../../../../common/Constants';
import { ConstantsLagoon } from '../../../../common/ConstantsLagoon';
import { ContentWrapper } from '../../../../common/ContentWrapper';
import {
  HeaderWrapper,
  HeadingContainer,
  ResultWrapper,
  headerTextStyle as defaultHeaderTextStyle,
} from '../../../../common/ResultSection/ResultSection.style';
import { useSaveOfferDisposition } from '../../../../hooks/useCeOffers';
import { useLagoon } from '../../../../hooks/useLagoon';
import {
  getCurrentMember,
  getEnterpriseId,
} from '../../../../utils/user.utils';
import { ProgramPromotionCard } from './ProgramPromotionCard';

const ProgramPromotionResults = ({
  programPromotionsForResultPage,
  isMixedResultsPage = false,
  headerTextStyle = defaultHeaderTextStyle,
  searchTerm = '',
}) => {
  const data = useLagoon('ui-messaging')();
  const programPromotionContent = find(data, {
    key: ConstantsLagoon.PROGRAM_PROMOTION.PROGRAM_PROMOTION_CONTENT,
  });

  const [isOpenPopover, setIsOpenPopover] = useState(false);
  const [, saveOfferDisposition] = useSaveOfferDisposition({});
  const currentMember = getCurrentMember();
  const enterpriseId = getEnterpriseId(currentMember);

  const offerTokensKey = useMemo(
    () =>
      programPromotionsForResultPage
        ?.map((offer) => offer?.offerToken)
        .filter(Boolean)
        .join(',') || '',
    [programPromotionsForResultPage]
  );

  const [sentTokensKey, setSentTokensKey] = useState('');

  useEffect(() => {
    if (!enterpriseId || !offerTokensKey || sentTokensKey === offerTokensKey)
      return;

    const offerTokens = offerTokensKey.split(',').filter(Boolean);

    offerTokens.forEach((offerToken) => {
      saveOfferDisposition({
        variables: {
          enterpriseId,
          disposition: Disposition.OFFER_CONTACT,
          offerToken,
        },
      });
    });

    setSentTokensKey(offerTokensKey);
  }, [enterpriseId, offerTokensKey, sentTokensKey]);

  return (
    <React.Fragment>
      <ContentWrapper>
        <HeaderWrapper css={{ marginTop: isMixedResultsPage ? '24px' : '0' }}>
          <ResultWrapper>
            <HeadingContainer>
              <Heading
                css={headerTextStyle}
                data-testid="Program-Promotion-Results-Header"
                display="h6"
                offset={2}
              >
                <div
                  data-testid="Program-Promotion-Results-Header-Title"
                  style={{
                    display: 'flex',
                    gap: '2px',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  {programPromotionContent?.title}

                  <Popover
                    aria-label="Program Promotion Section"
                    content={programPromotionContent?.message}
                    css={{
                      '.abyss-popover-title': {
                        marginRight: '2px',
                      },
                      '.abyss-popover-trigger': {
                        display: 'flex',
                        position: 'relative',
                        top: '2px',
                      },
                    }}
                    data-auto-testid="program-promotion-popover-icon"
                    data-testid="program-promotion-popover-icon"
                    onOpenChange={() => setIsOpenPopover(!isOpenPopover)}
                    open={isOpenPopover}
                    title={programPromotionContent?.title}
                    width={370}
                  >
                    <IconMaterial
                      data-auto-testid="program-promotion-popover-icon"
                      data-testid="program-promotion-popover-icon"
                      icon="info"
                      onClick={() => setIsOpenPopover(!isOpenPopover)}
                      size={16}
                      variant="outlined"
                    />
                  </Popover>
                </div>
              </Heading>
            </HeadingContainer>
          </ResultWrapper>
        </HeaderWrapper>
        <ProgramPromotionCard 
          offers={programPromotionsForResultPage} 
          searchTerm={searchTerm}
        />
      </ContentWrapper>
    </React.Fragment>
  );
};

export default ProgramPromotionResults;
